import { AdminApiClient, AuthenticatedApiClient, JwtAuthenticatedApiClient } from '@guiker/asset-shared'
import { useAuthenticatedApiClient, useJwtAuthenticatedApiClient } from '@guiker/react-framework'

export const useAssetAuthenticatedApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
export const useAssetAdminApiClient = useAuthenticatedApiClient(AdminApiClient)
export const useAssetJwtAuthenticatedApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
